import { render, staticRenderFns } from "./DisabledAccount.vue?vue&type=template&id=7b045262"
import script from "./DisabledAccount.vue?vue&type=script&lang=js"
export * from "./DisabledAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports